/**
 * @license
 * Copyright 2017 Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { shallowEqualsPartial } from "./internal/utils/shallowEqualsPartial";
export function setWith(state, ...overrides) {
    if (overrides.length === 1) {
        if (shallowEqualsPartial(state, overrides[0])) {
            return state;
        }
        else {
            return Object.assign(Object.assign({}, state), overrides[0]);
        }
    }
    else {
        const result = Object.assign({}, state, ...overrides);
        return shallowEqualsPartial(state, result) ? state : result;
    }
}
